// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/scheduling_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * @generated from message protogen.Schedule
 */
export class Schedule extends Message<Schedule> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string status = 2;
   */
  status = "";

  /**
   * @generated from field: int64 deadlineSec = 3;
   */
  deadlineSec = protoInt64.zero;

  /**
   * @generated from field: int64 creationDateSec = 4;
   */
  creationDateSec = protoInt64.zero;

  /**
   * @generated from field: int64 lastUpdatedSec = 5;
   */
  lastUpdatedSec = protoInt64.zero;

  /**
   * @generated from field: string payloadJson = 6;
   */
  payloadJson = "";

  /**
   * @generated from field: string recurringUnit = 7;
   */
  recurringUnit = "";

  /**
   * @generated from field: int32 recurringInterval = 8;
   */
  recurringInterval = 0;

  /**
   * @generated from field: string scheduleType = 9;
   */
  scheduleType = "";

  constructor(data?: PartialMessage<Schedule>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.Schedule";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "deadlineSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "creationDateSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "lastUpdatedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "payloadJson", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "recurringUnit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "recurringInterval", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "scheduleType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Schedule {
    return new Schedule().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Schedule {
    return new Schedule().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Schedule {
    return new Schedule().fromJsonString(jsonString, options);
  }

  static equals(a: Schedule | PlainMessage<Schedule> | undefined, b: Schedule | PlainMessage<Schedule> | undefined): boolean {
    return proto3.util.equals(Schedule, a, b);
  }
}

/**
 * @generated from message protogen.ListSystemSchedulesRequest
 */
export class ListSystemSchedulesRequest extends Message<ListSystemSchedulesRequest> {
  /**
   * @generated from field: bool includeCanceled = 1;
   */
  includeCanceled = false;

  /**
   * @generated from field: string taskType = 2;
   */
  taskType = "";

  constructor(data?: PartialMessage<ListSystemSchedulesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListSystemSchedulesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "includeCanceled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "taskType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSystemSchedulesRequest {
    return new ListSystemSchedulesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSystemSchedulesRequest {
    return new ListSystemSchedulesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSystemSchedulesRequest {
    return new ListSystemSchedulesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListSystemSchedulesRequest | PlainMessage<ListSystemSchedulesRequest> | undefined, b: ListSystemSchedulesRequest | PlainMessage<ListSystemSchedulesRequest> | undefined): boolean {
    return proto3.util.equals(ListSystemSchedulesRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListSystemSchedulesResponse
 */
export class ListSystemSchedulesResponse extends Message<ListSystemSchedulesResponse> {
  /**
   * @generated from field: repeated protogen.Schedule schedules = 1;
   */
  schedules: Schedule[] = [];

  constructor(data?: PartialMessage<ListSystemSchedulesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListSystemSchedulesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "schedules", kind: "message", T: Schedule, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListSystemSchedulesResponse {
    return new ListSystemSchedulesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListSystemSchedulesResponse {
    return new ListSystemSchedulesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListSystemSchedulesResponse {
    return new ListSystemSchedulesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListSystemSchedulesResponse | PlainMessage<ListSystemSchedulesResponse> | undefined, b: ListSystemSchedulesResponse | PlainMessage<ListSystemSchedulesResponse> | undefined): boolean {
    return proto3.util.equals(ListSystemSchedulesResponse, a, b);
  }
}

/**
 * @generated from message protogen.CreateSystemScheduleRequest
 */
export class CreateSystemScheduleRequest extends Message<CreateSystemScheduleRequest> {
  /**
   * @generated from field: int64 deadlineSec = 1;
   */
  deadlineSec = protoInt64.zero;

  /**
   * @generated from field: string payloadJson = 2;
   */
  payloadJson = "";

  /**
   * @generated from field: string recurringUnit = 3;
   */
  recurringUnit = "";

  /**
   * @generated from field: int32 recurringInterval = 4;
   */
  recurringInterval = 0;

  constructor(data?: PartialMessage<CreateSystemScheduleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateSystemScheduleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "deadlineSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "payloadJson", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "recurringUnit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "recurringInterval", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSystemScheduleRequest {
    return new CreateSystemScheduleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSystemScheduleRequest {
    return new CreateSystemScheduleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSystemScheduleRequest {
    return new CreateSystemScheduleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSystemScheduleRequest | PlainMessage<CreateSystemScheduleRequest> | undefined, b: CreateSystemScheduleRequest | PlainMessage<CreateSystemScheduleRequest> | undefined): boolean {
    return proto3.util.equals(CreateSystemScheduleRequest, a, b);
  }
}

/**
 * @generated from message protogen.CreateSystemScheduleResponse
 */
export class CreateSystemScheduleResponse extends Message<CreateSystemScheduleResponse> {
  /**
   * @generated from field: protogen.Schedule schedule = 1;
   */
  schedule?: Schedule;

  constructor(data?: PartialMessage<CreateSystemScheduleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateSystemScheduleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "schedule", kind: "message", T: Schedule },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateSystemScheduleResponse {
    return new CreateSystemScheduleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateSystemScheduleResponse {
    return new CreateSystemScheduleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateSystemScheduleResponse {
    return new CreateSystemScheduleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateSystemScheduleResponse | PlainMessage<CreateSystemScheduleResponse> | undefined, b: CreateSystemScheduleResponse | PlainMessage<CreateSystemScheduleResponse> | undefined): boolean {
    return proto3.util.equals(CreateSystemScheduleResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateSystemScheduleRequest
 */
export class UpdateSystemScheduleRequest extends Message<UpdateSystemScheduleRequest> {
  /**
   * @generated from field: string scheduleRef = 1;
   */
  scheduleRef = "";

  /**
   * @generated from field: int64 deadlineSec = 2;
   */
  deadlineSec = protoInt64.zero;

  /**
   * @generated from field: string recurringUnit = 3;
   */
  recurringUnit = "";

  /**
   * @generated from field: int32 recurringInterval = 4;
   */
  recurringInterval = 0;

  /**
   * @generated from field: string payloadJson = 5;
   */
  payloadJson = "";

  /**
   * @generated from field: string status = 6;
   */
  status = "";

  constructor(data?: PartialMessage<UpdateSystemScheduleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateSystemScheduleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scheduleRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "deadlineSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "recurringUnit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "recurringInterval", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "payloadJson", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSystemScheduleRequest {
    return new UpdateSystemScheduleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSystemScheduleRequest {
    return new UpdateSystemScheduleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSystemScheduleRequest {
    return new UpdateSystemScheduleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSystemScheduleRequest | PlainMessage<UpdateSystemScheduleRequest> | undefined, b: UpdateSystemScheduleRequest | PlainMessage<UpdateSystemScheduleRequest> | undefined): boolean {
    return proto3.util.equals(UpdateSystemScheduleRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateSystemScheduleResponse
 */
export class UpdateSystemScheduleResponse extends Message<UpdateSystemScheduleResponse> {
  /**
   * @generated from field: protogen.Schedule schedule = 1;
   */
  schedule?: Schedule;

  constructor(data?: PartialMessage<UpdateSystemScheduleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateSystemScheduleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "schedule", kind: "message", T: Schedule },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateSystemScheduleResponse {
    return new UpdateSystemScheduleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateSystemScheduleResponse {
    return new UpdateSystemScheduleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateSystemScheduleResponse {
    return new UpdateSystemScheduleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateSystemScheduleResponse | PlainMessage<UpdateSystemScheduleResponse> | undefined, b: UpdateSystemScheduleResponse | PlainMessage<UpdateSystemScheduleResponse> | undefined): boolean {
    return proto3.util.equals(UpdateSystemScheduleResponse, a, b);
  }
}

/**
 * @generated from message protogen.ExecuteSystemScheduleRequest
 */
export class ExecuteSystemScheduleRequest extends Message<ExecuteSystemScheduleRequest> {
  /**
   * @generated from field: string scheduleRef = 1;
   */
  scheduleRef = "";

  constructor(data?: PartialMessage<ExecuteSystemScheduleRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ExecuteSystemScheduleRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scheduleRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExecuteSystemScheduleRequest {
    return new ExecuteSystemScheduleRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExecuteSystemScheduleRequest {
    return new ExecuteSystemScheduleRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExecuteSystemScheduleRequest {
    return new ExecuteSystemScheduleRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ExecuteSystemScheduleRequest | PlainMessage<ExecuteSystemScheduleRequest> | undefined, b: ExecuteSystemScheduleRequest | PlainMessage<ExecuteSystemScheduleRequest> | undefined): boolean {
    return proto3.util.equals(ExecuteSystemScheduleRequest, a, b);
  }
}

/**
 * @generated from message protogen.ExecuteSystemScheduleResponse
 */
export class ExecuteSystemScheduleResponse extends Message<ExecuteSystemScheduleResponse> {
  constructor(data?: PartialMessage<ExecuteSystemScheduleResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ExecuteSystemScheduleResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExecuteSystemScheduleResponse {
    return new ExecuteSystemScheduleResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExecuteSystemScheduleResponse {
    return new ExecuteSystemScheduleResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExecuteSystemScheduleResponse {
    return new ExecuteSystemScheduleResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ExecuteSystemScheduleResponse | PlainMessage<ExecuteSystemScheduleResponse> | undefined, b: ExecuteSystemScheduleResponse | PlainMessage<ExecuteSystemScheduleResponse> | undefined): boolean {
    return proto3.util.equals(ExecuteSystemScheduleResponse, a, b);
  }
}

